export default __webpack_public_path__ + "static/media/runnerup_6.55f8a8f3.jpg";